import React, { Component } from 'react';

import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import faqHeaderBg from '../../assets/images/faqBg.png'
import Footer from '../../components/Footer'
import CategoryItemIcon from "../../components/Calculator-board/Category-item/Category-item-icon";
import rulesandconditionsbg from '../../assets/images/rulesandconditionsbg.png'


import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux'
// import {FaqContent}  from './faqContent'

import './CategoryDescription.css'

class CategoryDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }



    render() {
        return (
            <div className="category-description-container">
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                <div className="category-description-container-header">
                    <div className="category-description-container-header-background">
                        <img src={rulesandconditionsbg} alt="Compulsory Insurance Center" />
                    </div>
                    <div className="category-description-header-wrapper"> </div>
                    <div className="category-description-header-content">
                        <div className="category-description-header-text">
                            <h1>{this.props.translate("category-title")}</h1>
                            <h5>{this.props.translate("PolicySearchPortalByIndividualPersons")}</h5>
                        </div>
                    </div>
                </div>

                <div className="category-description-content">
                    <div className="category-description-content-header">
                        <span>{this.props.translate("category-items-header")}</span>
                    </div>
                    <div className="category-description-items">
                        <div className="category-description-item">
                            <div className="category-description-icon">
                                <CategoryItemIcon
                                    iconName="000000000000001"
                                    width={100}
                                />
                            </div>
                            <div className="category-description-text">
                                {this.props.translate("category-item-motocylce-header")}
                                <span>
                                    {this.props.translate("category-item-motocylce-content")}
                                </span>
                            </div>
                        </div>{/* category-description-item */}

                        <div className="category-description-item">
                            <div className="category-description-icon">
                                <CategoryItemIcon
                                    iconName="000000000000002"
                                    width={100}
                                />
                            </div>
                            <div className="category-description-text">
                                {this.props.translate("category-item-vehicle-header")}
                                <span>{this.props.translate("category-item-vehicle-content")}</span>
                            </div>
                        </div>{/* category-description-item */}

                        <div className="category-description-item">
                            <div className="category-description-icon">
                                <CategoryItemIcon
                                    iconName="000000000000003"
                                    width={100}
                                />
                            </div>
                            <div className="category-description-text">
                                {this.props.translate("category-item-bus-header")}
                                <span>{this.props.translate("category-item-bus-content")}</span>
                            </div>
                        </div>{/* category-description-item */}

                        <div className="category-description-item">
                            <div className="category-description-icon">
                                <CategoryItemIcon
                                    iconName="000000000000004"
                                    width={100}
                                />
                            </div>
                            <div className="category-description-text">
                                {this.props.translate("category-item-truck-header")}
                                <span>{this.props.translate("category-item-truck-content")}</span>
                            </div>
                        </div>{/* category-description-item */}

                        <div className="category-description-item">
                            <div className="category-description-icon">
                                <CategoryItemIcon
                                    iconName="000000000000005"
                                    width={100}
                                />
                            </div>
                            <div className="category-description-text">
                                {this.props.translate("category-item-Trailer-header")}
                                <span>{this.props.translate("category-item-Trailer-content")}</span>
                            </div>
                        </div>{/* category-description-item */}

                        <div className="category-description-item">
                            <div className="category-description-icon">
                                <CategoryItemIcon
                                    iconName="000000000000006"
                                    width={100}
                                />
                            </div>
                            <div className="category-description-text">
                                {this.props.translate("category-item-special-header")}
                                <span>{this.props.translate("category-item-special-content")} </span>
                            </div>
                        </div>{/* category-description-item */}
                    </div>
                </div>

                <Footer />

            </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),

})
export default connect(mapStateToProps)(CategoryDescription)



// WEBPACK FOOTER //
// ./src/pages/CategoryDescription/CategoryDescription.js